import { Component, OnInit, ViewChild } from '@angular/core';
import { Page } from '../classes/page';
import { AllotService } from '../services/Allot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditService } from '../services/audit.service';
import { ToastService } from '../toast/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { SweetAlertService } from '../toast/sweet-alert.service';
import { AuthService } from '../services/auth/auth.service';
import { firstValueFrom } from 'rxjs';
declare var bootstrap: any;
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SocietyService } from '../services/society.service';

@Component({
  selector: 'app-allot-auditor',
  templateUrl: './allot-auditor.component.html',
  styleUrls: ['./allot-auditor.component.scss'],
})
//Declare properties
export class AllotAuditorComponent implements OnInit {
  @ViewChild('formRef') formRef!: NgForm;
  page = new Page();
  rows: any[] = [];
  loading = false;
  columns: any[] = [];
  upload: boolean = false;
  errorMessage: string = '';
  filter: any = { iAuditorID: '', auditorname: '', keyword: '' };
  auditors: any[] = [];
  id: number | null = null;
  filteredRows: any[] = [];
  auditorName: any[] = [];
  auditorID: any;
  filteredData: any[] = [];
  filteredStatus: any;
  hideDivs: boolean = true;

  payment: boolean = false;
  base64String: string = '';
  iAllotAuditorID: any;
  today: string = '';
  cd: any;
  minAgmDate: string = '';
  //Constructor
  constructor(
    private allotService: AllotService,
    private authService: AuthService,
    private toastService: ToastService,
    private alertService: SweetAlertService,
    private sanitizer: DomSanitizer,
    private societyService: SocietyService,
    private auditService: AuditService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.page.pageNumber = 0;
    this.page.pageSize = 10;
    this.page.totalRecords = 0;
    const now = new Date();
    this.today = now.toISOString().split('T')[0];
  }
  societyClose: boolean = false;
  base64String2: string = '';
  transids: number = 0;
  bankList: any[] = [];
  branchList: any[] = [];
  formData: any = {
    iAuditorID: 0,
    agmDate: '',
    iSocietyDetailsID: 0,
    iResolutionNo: '',
    sUploadMomAGM: '',
    iAuditorIDType: 0,
    sAuditorEmail: '',
    sAuditorMobile: '',
    totalCompletedAudit: 0,
    totalAuditConducted: 0,
    currentYearTotalAllotted: 0,
    currentYearTotalCompleted: 0,
    sUploadMomFileName: '',
    sUploadMomExtension: '',
  };
  firstItem: any;
  fileName: string = '';
  fileExtension: string = '';
  selectedFile: File | null = null;
  datas: any;
  paymentdata: any = {
    sBanktype: '0',
    uploadScriptFileName: '',
    iSocietyDetailID: 0,
    iSocietyTranID: 0,
    paidAmount: 0,
    bankName: '',
    iSFCCode: '',
    bankBranch: '',
    paidThrough: '',
    transactionNo: '',
    uploadScriptPath: '',
    uploadScriptExtension: '',
  };

  allDataLoaded = false;
  ngOnInit(): void {
    this.societyClose =
      this.authService.currentUserValue?.societyRequestClose || false;


    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.id = parseInt(params['id']);
      }
    });
    const now = new Date();

    this.today = this.formatDateToInput(now);

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    this.minAgmDate = this.formatDateToInput(oneYearAgo);
    this.GetMasterData();
    this.setPage({ offset: 0 });
    this.auditdates();



    this.columns = [
      { prop: 'agmDate', name: 'Date of AGM' },
      { prop: 'iResolutionNo', name: 'Resolution No' },
      { prop: 'sAuditorType', name: 'Auditor Type' },
      { prop: 'sAuditorName', name: 'Auditor Name' },
      { prop: 'sAuditorMobile', name: 'Auditor Contact' },
      { prop: 'sAuditorEmail', name: 'Auditor Email' },
      { prop: 'auditApplicationNumber', name: 'Audit Application Number' },
    ];

  }


  bankTypeChange(value: any) {

    if (value && value !== '0') {
      this.loadBanks(value);
    } else {
      this.bankList = [];
      this.branchList = [];
      this.paymentdata.bankName = '0';
    }
  }
  loadBanks(type: string) {
    this.societyService.getBankDetails(type).subscribe({
      next: (res) => {
        this.bankList = res.data || [];
      },
      error: () => {
        this.bankList = [];
      }
    });
  }
  formatDateToInput(date: Date): string {
    return date.toISOString().split('T')[0];
  }
  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileExtension = this.getFileExtension(file.name).toLowerCase();

      const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];

      if (allowedExtensions.includes(this.fileExtension)) {
        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 2) {
          this.toastService.showError(
            'File size should be less than or equal to 2 MB'
          );
          this.formData.sUploadMomAGM = '';
          return;
        }

        this.selectedFile = file;
        this.convertToBase64(file, 1);
        this.cd.detectChanges();
        this.upload = false;
      } else {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );
        this.formData.sUploadMomAGM = '';
      }
    }
  }
  onPasteNumber(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text') || '';

    if (!/^\d+$/.test(pastedData)) {
      event.preventDefault();
    }
  }
  voterListBase64: string = '';
  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (from === 1) {
        this.base64String = reader.result as string;
        this.voterListBase64 = reader.result as string;
      }
      if (from === 2) {
        this.base64String2 = reader.result as string;
      }
    };
  }
  openPicker(picker: HTMLInputElement) {
    picker.showPicker?.();
    picker.focus();
  }

  validateNumber(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  base64ToBlob(base64: any, contentType = "", sliceSize = 512): Blob {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
  selectedContent: string = '';
  base64Pdf: SafeResourceUrl = '';
  previewFile(file: any, model: any): void {

    if (!file) return;
    const blob = this.base64ToBlob(file, "application/pdf");
    this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    this.openModals(model)
  }
  openModals(content: string): void {
    this.selectedContent = content;
    const modalElement = document.getElementById(content);
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }
  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }
  formatDateToDDMMYYYY(date: string): string {
    if (!date) return '';

    const d = new Date(date);
    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  }

  //Get DropDown data
  GetMasterData(): void {
    this.auditService.getDropDownValues().subscribe(
      (response) => {
        if (response.status === 200) {
          this.auditors = response.data.auditors;
        }
      },

    );
  }

  preventInvalidResolution(event: any): void {
    const value = +event.target.value;
    if (value < 1) {
      event.target.value = '';
      this.formData.iResolutionNo = null;
    }
  }

  // Called when pagination changes
  setPage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.loadAuditorsFromApi();
  }

  // Called when search is triggered by filters
  search() {
    this.page.pageNumber = 0;
    this.loadAuditorsFromApi();
  }

  onRowsPerPageChange() {
    this.page.pageNumber = 0;
    this.loadAuditorsFromApi();
  }
  loadAuditorsFromApi() {
    this.loading = true;

    const requestParams = {
      pageSize: this.page.pageSize,
      pageNumber: this.page.pageNumber,
      filter: {
        auditorname: this.filter.auditorname || null,
        iAuditorID: this.filter.iAuditorID || null,
        keyword: this.filter.keyword || null,
      },
    };

    this.allotService.getAllAllotAuditors(requestParams).subscribe({
      next: (response) => {
        this.loading = false;

        if (
          response.status === 200 &&
          Array.isArray(response.data.lstAllowAuditor)
        ) {
          const resultList = response.data.lstAllowAuditor;

          this.rows = resultList.map((item: any) => ({
            ...item,
            agmDate: this.formatDate(item.agmDate),
            showchecklist: item.isAuditProcessComplete,
            showPaymentDone: item.isPaymentDone ? false : true,
          }));


          // Even if resultList is empty, update table state
          this.rows = [...this.rows]; // ✅ triggers change detection
          this.page.totalRecords =
            response.totalRecords || this.rows.length || 0;
        } else {
          this.rows = [];
          this.page.totalRecords = 0;
        }
      },
      error: () => {
        this.loading = false;
        this.rows = [];
        this.page.totalRecords = 0;
      },
    });
  }

  applyFiltersAndPagination() {
    this.filteredRows = this.rows.filter((item) => {
      const auditorNameMatch =
        !this.filter.auditorname ||
        (item.auditorname &&
          item.auditorname
            .toLowerCase()
            .includes(this.filter.auditorname.toLowerCase()));

      const auditorIDMatch =
        this.filter.iAuditorID === undefined ||
        item.iAuditorID === this.filter.iAuditorID;

      const keywordMatch =
        !this.filter.keyword ||
        (item.name &&
          item.name
            .toLowerCase()
            .includes(this.filter.keyword.toLowerCase())) ||
        (item.mobile && item.mobile.includes(this.filter.keyword));

      return auditorNameMatch && auditorIDMatch && keywordMatch;
    });

    // Apply pagination
    const start = this.page.pageNumber * this.page.pageSize;
    const end = start + this.page.pageSize;
    this.filteredRows = this.filteredRows.slice(start, end);
  }

  // Load Auditors from API
  formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);

    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    return `${date.getDate().toString().padStart(2, '0')} / ${monthNames[date.getMonth()]
      } / ${date.getFullYear()}`;
  }

  processToViewChecklist(isocietydetailsid: number, transId: number) {
    this.transids = transId;
    this.id = isocietydetailsid;
    this.router.navigate(['/audit/view-checklist', this.id, this.transids]);
  }

  //Method for get View data from table by Id
  loadAuditors(id: number): void {
    this.allotService.getAllotAuditorDetails(id).subscribe(
      (response: any) => {
        this.filteredData = response.data;
        //  this.toastService.showSuccess(response.message);
      },
      (error: { message: string }) => {
        this.toastService.showError(error.message);
      }
    );
  }

  //Method for get View data from table by Id
  auditStatus(id: number, iAllotAuditorID: number): void {
    this.allotService.getAllotAuditorStatus(id, iAllotAuditorID).subscribe(
      (response: any) => {
        this.filteredStatus = response.data;
      },
      (error: { message: string }) => {
        this.toastService.showError(error.message);
      }
    );
  }
  auditData: any;
  auditdates(): void {
    this.allotService.getAuditAssignDate().subscribe(
      (response: any) => {
        this.auditData = response.data;

        this.setAllotAuditorButtonStatus();

      },
      (error: { message: string }) => {
        this.toastService.showError(error.message);
      }
    );
  }
  isAllotAuditorDisabled: boolean = false;
  setAllotAuditorButtonStatus(): void {

    const arAuditData = this.auditData.find((row: any) => row.arAuditStartDate && row.arAuditEndDate);

    if (!arAuditData?.arAuditEndDate || !arAuditData?.sAuditStartDate) {
      this.isAllotAuditorDisabled = false;
      return;
    }

    const normalize = (date: Date) => {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    };

    const today = normalize(new Date());

    const rawArEnd = new Date(arAuditData.arAuditEndDate);
    const rawSStart = new Date(arAuditData.sAuditStartDate);

    const arAuditEndDate = normalize(new Date(rawArEnd.getTime() + 24 * 60 * 60 * 1000));
    const sAuditStartDate = normalize(new Date(rawSStart.getTime() - 24 * 60 * 60 * 1000));

    this.isAllotAuditorDisabled = today > arAuditEndDate;
  }

  // async openAllotAuditorModal() {

  //   const arAuditData = this.auditData.find(
  //     (row: any) => row.sAuditStartDate || row.sAuditEndDate
  //   );


  //   const normalize = (date: any): Date => {
  //     const d = new Date(date);
  //     d.setHours(0, 0, 0, 0);
  //     return d;
  //   };

  //   const today = normalize(new Date());
  //   const sStartDate = normalize(arAuditData.sAuditStartDate); 
  //   const sEndDate = normalize(arAuditData.sAuditEndDate); 
  //   const arEndDate = normalize(arAuditData.arAuditEndDate);   


  //   const currentYear = today.getFullYear();
  //   const auditInProcess = this.rows.find((row: any) => {
  //     const agmYear = row.agmDate ? new Date(row.agmDate).getFullYear() : null;
  //     return (
  //       row.auditApplicationNumber === 'Audit in Process' &&
  //       agmYear === currentYear
  //     );
  //   });

  //   if (auditInProcess) {
  //     this.toastService.showError('Audit already in process for the current year.');
  //     return;
  //   }

  //   if (today >= sStartDate && today <= sEndDate) {
  //     const modalElement = document.getElementById('AllotAuditor');
  //     if (modalElement) {
  //       const modal = new (window as any).bootstrap.Modal(modalElement);
  //       modal.show();
  //     } else {
  //       console.warn('Modal element not found: #AllotAuditor');
  //     }
  //   } 
  //    else if (today <= arEndDate) {
  //     await this.alertService.confirmAlert(
  //       'Allotment',
  //       'Audit allotment should be done through AR side.',
  //       'OK',
  //       'Close'
  //     );
  //   }
  //  else {
  //     await this.alertService.confirmAlert(
  //       'Allotment',
  //       'Audit allotment is already done for this year.',
  //       'OK',
  //       'Close'
  //     );
  //   }
  // }
  openAllotAuditorModal() {
    const modalElement = document.getElementById('AllotAuditor');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    } else {
      console.warn('Modal element not found: #AllotAuditor');
    }
  }


  auditorData: any;
  DropDownData(auditorId: number): void {
    this.allotService.getDropDownAuditorList(auditorId).subscribe(
      (response) => {
        if (response.status === 200) {
          this.auditorName = response.data;


          (this.formData.iAuditorIDType = 0),
            (this.formData.sAuditorMobile = '');
          this.formData.sAuditorEmail = '';

          this.hideDivs = auditorId !== 17;
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        //  this.toastService.showError(error.message);
      }
    );
  }
  GetData() {
    const selectedID = Number(this.formData.iAuditorIDType);
    const selectedAuditor = this.auditorName.find(
      (auditor) => auditor.iUserID === selectedID
    );

    if (!selectedAuditor) return;

    this.formData.sAuditorMobile = selectedAuditor.mobile;
    this.formData.sAuditorEmail = selectedAuditor.emailID;

    if (selectedAuditor.auditorID !== 17) {
      this.formData.totalAuditConducted = selectedAuditor.totalAuditConducted;
      this.formData.totalCompletedAudit = selectedAuditor.totalCompletedAudit;
      this.formData.currentYearTotalAllotted = selectedAuditor.currentYearTotalAllotted,
        this.formData.currentYearTotalCompleted = selectedAuditor.currentYearTotalCompleted
      this.hideDivs = false;
    } else {
      this.hideDivs = true;
    }
  }

  isSubmitting = false;

  submitAuditorForm(): void {
    const tempAuditortypeId = Number(this.formData.iAuditorID);
    if (tempAuditortypeId == 0) {
      setTimeout(() => {
        this.toastService.showError('AuditorId Always Greater then 0');
      }, 500);
      return;
    }
    this.isSubmitting = true;

    this.formData.iAuditorID = Number(this.formData.iAuditorID);
    this.formData.sUploadMomAGM = this.base64String || '';
    this.formData.iSocietyDetailsID = this.id || 0;
    this.formData.sUploadMomFileName = this.fileName;
    this.formData.sUploadMomExtension = this.fileExtension;

    this.allotService.addAllotAuditor(this.formData).subscribe(
      (response: any) => {
        if (response?.status === 200) {
          this.toastService.showSuccess(response?.message);
        } else if (response?.status === 0) {
          this.toastService.showError(response?.message);
        }

        this.resetForm();
        this.isSubmitting = false;
        this.setPage({ offset: 0 });
      },
      (error: HttpErrorResponse) => {
        this.toastService.showError(error.message);
        this.isSubmitting = false;
      }
    );
  }

  isFormValid(): boolean {
    if (
      !this.formData.agmDate ||
      !this.formData.iResolutionNo ||
      !this.formData.sUploadMomAGM ||
      !this.formData.iAuditorID
    ) {
      return false;
    }

    if (this.formData.iAuditorID != 17) {
      if (
        !this.formData.iAuditorIDType ||
        !this.formData.sAuditorEmail ||
        !this.formData.sAuditorMobile
      ) {
        return false;
      }
    }

    return true;
  }

  resetForm(): void {
    this.formData = {
      iAllotAuditorID: 0,
      iSocietyDetailsID: 15,
      iAuditorID: 0,
      iAuditorIDType: 0,
      agmDate: '',
      iResolutionNo: 0,
      sUploadMomAGM: '',
      iAuditorTypeID: 0,
      sAuditorEmail: '',
      sAuditorMobile: '',
      totalCompletedAudit: 0,
      totalAuditConducted: 0,
      // iAuditorId: 0,
    };

    if (this.formRef) {
      this.formRef.resetForm(this.formData);
    }
  }

  openDeleteModal(id: number): void {
    this.id = id;
  }
setPaidAmount(row: any) {

  this.paymentdata.paidAmount = row.auditFees || 0;
  this.paymentdata.iSFCCode = row.sIFSCCode || '';
  this.paymentdata.sBanktype = row.sBanktype || ''

  this.loadBanks(this.paymentdata.sBanktype);

  setTimeout(() => {

    this.paymentdata.bankName = row.sBankName || '';

    this.onBankSelected();

    setTimeout(() => {
      this.paymentdata.bankBranch = row.sBranchName || '';
    }, 300);

  }, 300);

}

  onBankSelected() {

    const bankType = this.paymentdata.sBanktype;
    const bankName = this.paymentdata.bankName;

    if (bankName && bankName !== '0') {
      this.societyService.GetBranchList(bankType, bankName).subscribe(res => {
        this.branchList = res.data;
      });
    }

  }
  onBranchSelected() {

    const bankType = this.paymentdata.sBanktype;
    const bankName = this.paymentdata.bankName;
    const branchName = this.paymentdata.bankBranch;

    if (branchName && branchName !== '0') {
      this.societyService.GetBranchDetails(bankType, bankName, branchName).subscribe(res => {

        const d = res.data;

        this.paymentdata.iSFCCode = d?.ifscCode || '';

      });
    }

  }




  confirmDelete(): void {
    if (this.id !== null) {
      this.allotService.deleteAudit(this.id).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);

          this.setPage({ offset: 0 });
        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    }
  }

  onSubmit(form: any) {
   
      const requestParams = {
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        filter: {
          auditorname: this.filter.auditorname || null,
          iAuditorID: this.filter.iAuditorID || null,
          keyword: this.filter.keyword || null,
        },
      };

      this.allotService.getAllAllotAuditors(requestParams).subscribe({
        next: (response: any) => {
          // Check if response.data exists and is an array with at least one item
          this.firstItem = response.data;

          // Ensure lstAllowAuditor exists before accessing its properties
          if (this.firstItem?.lstAllowAuditor) {
            this.paymentdata.iSocietyTranID =
              this.firstItem.lstAllowAuditor[0].iSocietyTransID ?? 0;
            this.paymentdata.iSocietyDetailID =
              this.firstItem.lstAllowAuditor[0].iSocietyDetailsID ?? 0;
          }

          this.paymentdata.uploadScriptPath = this.base64String || '';
          this.paymentdata.uploadScriptFileName = this.fileName;
          this.paymentdata.uploadScriptExtension = this.fileExtension;
          // Call payment API
          this.allotService.payment(this.paymentdata).subscribe({
            next: (paymentResponse: any) => {
              if (paymentResponse?.status === 200) {
                this.toastService.showSuccess(paymentResponse?.message);
                window.location.reload();
              } else {
                this.toastService.showError(paymentResponse?.message);
              }
            },
            error: (error: HttpErrorResponse) => {
              console.error('Payment API Error:', error);
              this.toastService.showError(error.message);
            },
          });
        },
        error: (error: HttpErrorResponse) => {
          console.error('Allot Auditor API Error:', error);
          this.toastService.showError(error.message);
        },
      });
    
  }
onPaidThroughChange() {

  if (this.paymentdata.paidThrough === 'Cash') {

    this.paymentdata.sBanktype = '';
    this.paymentdata.bankName = '';
    this.paymentdata.bankBranch = '';
    this.paymentdata.iSFCCode = '';
    this.paymentdata.transactionNo = '';

  }

}

  // Function to reset form and payment data
  resetsForm(form: any) {
    this.paymentdata = {
      iSocietyDetailID: 0,
      iSocietyTranID: 0, // Changed from empty string to number for consistency
      paidAmount: 0,
      bankName: '',
      iSFCCode: '',
      bankBranch: '',
      paidThrough: '',
      transactionNo: '',
      uploadScriptPath: '',
    };

    // Ensure form reset function exists
    if (form.reset) {
      form.reset();
    }
  }
}
